export default "__VITE_ASSET__CanoOV6E__"